import type { ReactNode } from 'react'

import { DIALOG_ACTIONS_ATTRIBUTE } from '@gto/helpers/dialog-keys'
import { cn } from '@gto/ui/cn'

type FooterProps = {
  children?: ReactNode
  className?: string
}

export const Footer = ({ children, className }: FooterProps) => {
  // The attribute tells `Dialog.Popup` where the call to action of this dialog
  // is, so Enter can press it.
  return (
    <div
      {...{ [DIALOG_ACTIONS_ATTRIBUTE]: '' }}
      className={cn('flex justify-end gap-4 pt-4', className)}
    >
      {children}
    </div>
  )
}
